module.exports = __webpack_public_path__ + "img/but_h5.2867b5bf.png";